
import { ContractExtensionEligibilityInfo } from '@/models/contractExtension/ContractExtensionEligibilityModel';
import { CourseModel } from '@descomplica/dex-models';
import { Button, ButtonDropdown, Icon } from '@descomplica/vue-components';
import Vue from 'vue';
import {
  ContractExtensionOptionWithPrice,
  formatExtensionOptionsWithPrice,
} from '@/helpers/postgradContractExtension/formatOptions';

export interface MessageSection {
  header?: string;
  message: string;
}

export default Vue.extend({
  components: { Button, ButtonDropdown, Icon },
  props: {
    currentCourse: {
      type: Object as Vue.PropType<CourseModel>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    messageSections: {
      type: Array as Vue.PropType<MessageSection[]>,
      required: true,
    },
    userHasOtherCourses: {
      type: Boolean,
      default: false,
    },
    canExtendCurrentContract: {
      type: Boolean,
      default: false,
    },
    extendContractInfo: {
      type: Object as Vue.PropType<ContractExtensionEligibilityInfo>,
      default: null,
    },
    userHasFinishedCourse: {
      type: Boolean,
      default: false,
    },
    showCertificateDownloadButton: {
      type: Boolean,
      default: true,
    },
    imageLink: {
      type: String,
      required: true,
    },
  },
  computed: {
    showExtensionButton(): boolean {
      return !this.userHasFinishedCourse && this.canExtendCurrentContract;
    },
    formattedExtensionOptions(): ContractExtensionOptionWithPrice[] {
      if (!this.extendContractInfo) return [];
      return formatExtensionOptionsWithPrice(this.extendContractInfo);
    },
  },
  methods: {
    downloadCertificate(): void {
      this.$emit('onCertificateDownload');
    },
    redirectToLanding(): void {
      this.$emit('onLandingRedirect');
    },
    signOut(): void {
      this.$emit('onSignOut');
    },
  },
});
